import { Grid } from '@material-ui/core'
import TextField from 'src/components/ui/TextField'
type Props = {
  control?: any
  errors?: any
  register?: any
  loadingCep?: boolean
  type: 'normal' | 'company'
}
export default function Address({
  control,
  errors,
  register,
  loadingCep,
  type
}: Props) {
  const loadingDados = false
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        <TextField
          disabled={loadingCep}
          type="tel"
          size="medium"
          erro={errors}
          mask="99999-999"
          control={control}
          inputProps={{ maxLength: 64 }}
          name={type === 'company' ? 'companyCep' : 'cep'}
          label="CEP *"
          placeholder="00000-000"
          InputLabelProps={{
            shrink: true
          }}
          loading={loadingCep}
          id={`input-cep-address-${type}`}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyState' : 'state'}
          label="Estado *"
          placeholder="UF"
          InputLabelProps={{
            shrink: true
          }}
          id={`input-state-address-${type}`}
        />
      </Grid>

      <Grid item xs={12} sm={5}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyCity' : 'city'}
          label="Cidade *"
          placeholder="Cidade"
          InputLabelProps={{
            shrink: true
          }}
          id={`input-city-address-${type}`}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyStreet' : 'street'}
          label="Endereço *"
          placeholder="Rua, avenida..."
          InputLabelProps={{
            shrink: true
          }}
          id={`input-street-address-${type}`}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyNeighborhood' : 'neighborhood'}
          label="Bairro *"
          placeholder="Bairro"
          InputLabelProps={{
            shrink: true
          }}
          id={`input-neighborhood-address-${type}`}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyStreetNumber' : 'streetNumber'}
          label="Número *"
          placeholder="Nº"
          InputLabelProps={{
            shrink: true
          }}
          id={`input-street-number-address-${type}`}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          control={control}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyComplementary' : 'complementary'}
          label="Complemento *"
          placeholder="Apto, sala, bloco..."
          InputLabelProps={{
            shrink: true
          }}
          id={`input-complementary-address-${type}`}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          disabled={loadingDados}
          size="medium"
          erro={errors}
          inputRef={register}
          control={control}
          inputProps={{ maxLength: 100 }}
          name={type === 'company' ? 'companyReferencePoint' : 'referencePoint'}
          label="Ponto de referência *"
          placeholder="Ponto de referência"
          InputLabelProps={{
            shrink: true
          }}
          id={`input-reference-point-address-${type}`}
        />
      </Grid>
    </Grid>
  )
}
